import { css, jsx } from '@emotion/core';
import React, { useEffect } from 'react';

import Container from '@/src/shared/components/Container';
import Layout from '@/src/shared/components/Layout';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';

const surveySrc =
  'https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgd_2BubSJEoVMSXyhpZ3VDb5_2BldicKBME_2Fid_2Fdjp4V4Halv.js';
const linkId = 'apci-smcx-link';

const style = {
  smcxContainer: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .smcx-widget {
      z-index: 0;
    }
  `,
};

const SurveyMonkey = () => {
  useEffect(() => {
    /* eslint-disable */
    (function(t, e, s, n) {
      var o, a, c;
      (t.SMCX = t.SMCX || []),
        e.getElementById(n) ||
          ((a = e.getElementById(linkId)),
          (c = e.createElement(s)),
          (c.type = 'text/javascript'),
          (c.async = !0),
          (c.id = n),
          (c.src = surveySrc),
          a.parentNode.insertBefore(c, a));
    })(window, document, 'script', 'smcx-sdk');
  }, []);

  return (
    <Layout>
      <Section>
        <Container>
          <div css={style.smcxContainer}>
            <div id={linkId} />
          </div>
        </Container>
      </Section>
      <WebLogImage browserPath title="Site Feedback" />
    </Layout>
  );
};

export default SurveyMonkey;
